import React from 'react';
import { StyledProgress } from './styled';

export const Progress = ({ ...props }) => {
    return <StyledProgress {...props} />;
};
